import axios from 'axios';

const api = axios.create({
  baseURL: 'https://hml.back.digitrack.metaglobaltech.com',
});

export default api;
